// ─────────────────────────────────────────────────────────────────────────────
// BottomBar.jsx  —  Mobile-only bottom navigation bar
//
// Shown only on screens smaller than lg (1024px). Hidden on desktop.
// Includes iPhone safe-area-inset-bottom for notch support.
//
// WHAT TO EDIT HERE:
//   Tab items          → edit BOTTOM_NAV_ITEMS in constants.js
//   Active color       → change "text-blue-600" in the button className
//   Background / border → change bg-white and border-gray-200 on the wrapper
//
// PROPS:
//   mobileView    {string}   current active mobile view key
//   setMobileView {fn}       switch mobile view
//   rightTab      {string}   current right-panel tab (to highlight Chat correctly)
//   setRightTab   {fn}       switch right panel tab
// ─────────────────────────────────────────────────────────────────────────────

import { BOTTOM_NAV_ITEMS } from "./constants";

export default function BottomBar({ mobileView, setMobileView, rightTab, setRightTab }) {
  const handlePress = (key) => {
    if (key === "chat_m") {
      // Special case: Chat tab opens the detail view with the chat tab selected
      setMobileView("detail");
      setRightTab("chat");
    } else {
      setMobileView(key);
    }
  };

  const isActive = (key) => {
    if (key === "chat_m") return mobileView === "detail" && rightTab === "chat";
    return mobileView === key;
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex z-30 lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {BOTTOM_NAV_ITEMS.map(item => (
        <button
          key={item.key}
          onClick={() => handlePress(item.key)}
          className={`flex-1 flex flex-col items-center justify-center py-2 gap-0.5 transition-colors ${
            isActive(item.key) ? "text-blue-600" : "text-gray-400"
          }`}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
            {item.icon.split(" M").map((seg, i) => (
              <path key={i} strokeLinecap="round" strokeLinejoin="round" d={i === 0 ? seg : "M" + seg}/>
            ))}
          </svg>
          <span className="text-[10px] font-medium">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
